module.exports = __webpack_public_path__ + "img/Lighttpd.6e907ee.svg";